import type { ApolloClient } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import { UsercentricsProvider } from '@s-group/react-usercentrics';
import { ThemeProvider } from 'next-themes';
import type { ReactNode } from 'react';

import { BreakpointMediaContextProvider } from '../breakpoints/media';

import type { Environment } from './EnvironmentContext';
import { EnvironmentProvider } from './EnvironmentContext';
import { MediaContextProvider } from './MediaContext';
import { TimeContextProvider } from './TimeContext';
import { TrackingProvider } from './TrackingProvider';

type Props = {
	children: ReactNode;
	apolloClient: ApolloClient;
	environment: Environment;
};

export function ContextProvider({ children, apolloClient, environment }: Props) {
	return (
		<EnvironmentProvider environment={environment}>
			<ApolloProvider client={apolloClient}>
				<BreakpointMediaContextProvider>
					<TrackingProvider>
						<MediaContextProvider>
							<ThemeProvider disableTransitionOnChange={true}>
								<UsercentricsProvider>
									<TimeContextProvider>{children}</TimeContextProvider>
								</UsercentricsProvider>
							</ThemeProvider>
						</MediaContextProvider>
					</TrackingProvider>
				</BreakpointMediaContextProvider>
			</ApolloProvider>
		</EnvironmentProvider>
	);
}
